import { cn } from '../../lib/utils'
import { mediaUrl } from '../../services/config'
import { displayInitial } from '../../utils/displayInitial'

export interface AvatarProps {
  /** Display name — its first letter is the no-image fallback (DM-chat style). */
  name: string | null | undefined
  /** Image URL (server-relative or absolute). Resolved through mediaUrl(). */
  src?: string | null
  /**
   * Sizing + letter size, e.g. "h-7 w-7 text-xs". The base look (round,
   * bg-primary circle with the initial) is fixed so every module renders
   * the same fallback as the DM chat list.
   */
  className?: string
}

// Design-kit avatar: image when present, otherwise the first letter of the
// name on a primary circle — the platform-wide "no photo" treatment. Use
// this instead of hand-rolled `{x.avatarUrl && <img/>}` blocks, which left
// empty gray circles all over the app.
export function Avatar({ name, src, className }: AvatarProps) {
  return (
    <div
      className={cn(
        'rounded-full shrink-0 overflow-hidden flex items-center justify-center bg-primary text-primary-foreground font-bold select-none',
        className,
      )}
    >
      {src ? (
        <img src={mediaUrl(src)} alt="" className="h-full w-full object-cover" />
      ) : (
        displayInitial(name)
      )}
    </div>
  )
}
